export { default } from "./useLazyKeyTermsGet";
